import Component from "../Component";
import "ion-rangeslider";
import "ion-rangeslider/css/ion.rangeSlider.min.css"

export default class Slider extends Component {
    constructor(element) {
        super(element);

        let config = {
            skin: "flat",
            grid: true,
            from_fixed: true,
            to_fixed: true
        };

        if (element.hasOwnProperty('data-type')) {
            config['type'] = element.getAttribute('data-type');
        }
        if (element.hasOwnProperty('data-min')) {
            config['min'] = element.getAttribute('data-min');
        }
        if (element.hasOwnProperty('data-max')) {
            config['max'] = element.getAttribute('data-max');
        }
        if (element.hasOwnProperty('data-frommin')) {
            config['from_min'] = element.getAttribute('data-frommin');
        }
        if (element.hasOwnProperty('data-frommax')) {
            config['from_max'] = element.getAttribute('data-frommax');
        }
        if (element.hasOwnProperty('data-from')) {
            config['from'] = element.getAttribute('data-from');
        }
        if (element.hasOwnProperty('data-to')) {
            config['to'] = element.getAttribute('data-to');
        }
        if (element.hasOwnProperty('data-fromfixed')) {
            config['from_fixed'] = true;
        }
        if (element.hasOwnProperty('data-tofixed')) {
            config['to_fixed'] = true;
        }
        if (element.hasOwnProperty('data-grid') && element.getAttribute('data-grid') === 'false') {
            config['grid'] = false;
        } else {
            config['grid'] = true;
        }

        let onStart = false;

        if (element.getAttribute('data-prefixfrom') !== null) {
            config['prefix_from'] = element.getAttribute('data-prefixfrom');
            onStart = true;
        }
        if (element.getAttribute('data-prefixto') !== null) {
            config['prefix_to'] = element.getAttribute('data-prefixto');
            onStart = true;
        }

        if (onStart === true) {
            config['prettify'] = function(val) {
                if (val === Math.round(this.from) &&
                    this.hasOwnProperty('prefix_from')) {
                    return this.prefix_from + val;
                } else if (val === Math.round(this.to) &&
                    this.hasOwnProperty('prefix_to')) {
                    return this.prefix_to + val;
                } else {
                    return val;
                }
            }
        }

        $(element).ionRangeSlider(config);
    }

}

Component.parse(".ui-slider", Slider);



// WEBPACK FOOTER //
// ./src/components/ionslider/Slider.js